import axios from "axios";

document.addEventListener("DOMContentLoaded", () => {
	let cart_buttons = document.querySelectorAll(".add_to_cart");
	let products = document.querySelectorAll(".loop-product");
	let coupsdecoeurs = document.getElementById("produits_coup_de_coeurs");

	if (coupsdecoeurs) {
		var app = new Vue({
			el: "#produits_coup_de_coeurs",
			data: {
				loading: true,
				produits: [],
				coupsdecoeur: [],
				message: '<center><b>Chargement de vos coups de coeur.</b><br />Veuillez patientez quelques instants...<br /><br /><i class="fal fa-spin fa-spinner"></i></center>',
			},
			methods: {
				showProductBG() {
					let products = document.querySelectorAll(".loop-product");
					if (products) {
						products.forEach((el) => {
							if (isInViewport(el)) {
								var image = el.querySelector(".image");
								image.style.backgroundImage = "url(" + image.dataset.bg1 + ")";
							}
						});
						products.forEach((el) => {
							el.addEventListener("mouseenter", () => {
								var image = el.querySelector(".image");
								image.style.backgroundImage = "url(" + image.dataset.bg2 + ")";
							});
						});
						products.forEach((el) => {
							el.addEventListener("mouseleave", () => {
								var image = el.querySelector(".image");
								image.style.backgroundImage = "url(" + image.dataset.bg1 + ")";
							});
						});
					}
				},
			},
			mounted() {
				this.coupsdecoeur = JSON.parse(localStorage.getItem("favoris"));
				if (this.coupsdecoeur.length > 0) {
					this.coupsdecoeur.forEach((item) => {
						axios({
							url: "https://www.zanaga.fr/api/custom_service/",
							method: "POST",
							params: {
								service: "get_produits",
								id: item,
							},
						})
							.then((res) => {
								if (res.data.result.id != "0") {
									this.produits.push(res.data.result);
								}
								this.showProductBG();
							})
							.catch((err) => {
								console.log(err);
							});
					});
				}
			},
		});
	}

	window.addEventListener("scroll", showProductBG);

	function showProductBG() {
		let products = document.querySelectorAll(".loop-product");
		if (products) {
			products.forEach((el) => {
				if (isInViewport(el)) {
					var image = el.querySelector(".image");
					image.style.backgroundImage = "url(" + image.dataset.bg1 + ")";
				}
			});
		}
	}

	function isInViewport(elem) {
		var bounding = elem.getBoundingClientRect();
		return (
			bounding.top >= 0 &&
			bounding.left >= 0 &&
			bounding.top <= (window.innerHeight || document.documentElement.clientHeight) &&
			bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	}

	if (products) {
		products.forEach((el) => {
			el.addEventListener("mouseenter", () => {
				var image = el.querySelector(".image");
				image.style.backgroundImage = "url(" + image.dataset.bg2 + ")";
			});
		});
		products.forEach((el) => {
			el.addEventListener("mouseleave", () => {
				var image = el.querySelector(".image");
				image.style.backgroundImage = "url(" + image.dataset.bg1 + ")";
			});
		});
	}

	let filtres = document.querySelectorAll(".filter");
	if (filtres) {
		filtres.forEach((el) => {
			el.addEventListener("click", () => {
				el.classList.toggle("selected");
				updateProductsWithFilter();
			});
		});
	}

	const updateProductsWithFilter = () => {
		let goodclasses = document.querySelectorAll(".filter.selected:not(.cat)");
		if (goodclasses.length > 0 && products) {
			products.forEach((el) => {
				let contain = 0;
				goodclasses.forEach((item) => {
					if (item.dataset.val) {
						console.log(item.dataset.val.toLowerCase().replace(/\s/g, "-"), el.classList);
						if (el.classList.contains(item.dataset.val.toLowerCase().replace(/\s/g, "-"))) {
							contain++;
						}
					}
				});
				if (contain > 0) {
					el.classList.remove("hidden");
				} else {
					el.classList.add("hidden");
				}
			});
		} else {
			products.forEach((el) => {
				el.classList.remove("hidden");
			});
		}
	};

	cart_buttons.forEach((item) => {
		item.addEventListener("click", (e) => {
			e.preventDefault();
			item.innerHTML = '<i class="fal fa-spin fa-spinner"></i>';
			axios({
				method: "POST",
				url: "https://www.zanaga.fr/api/custom_service",
				params: {
					service: "addtocart",
					id: item.dataset.id,
				},
			})
				.then(() => {
					axios({
						method: "POST",
						url: "https://www.zanaga.fr/api/custom_service",
						params: {
							service: "comptepanier",
						},
					}).then((res) => {
						let cart_total = document.getElementById("cart_total");
						cart_total.innerHTML = res.data.result.count;
						item.innerHTML = '<i class="fal fa-check"></i> C\'est dans votre panier !';
					});
				})
				.catch((err) => {
					alert("Une erreur est survenue pendant l'ajout de votre produit au panier.");
				});
		});
	});
});
